// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__Attributes$SmartcutsMacros = require("./DOM__Attributes.bs.js");

var typecaseFromElement = (x => x);

function ofElement(element) {
  var tagName = element.tagName.toLowerCase();
  var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
  var attributesWithLowercaseType_type_ = OptionUtils$SmartcutsMacros.map(attributes.type_, $$String.lowercase_ascii);
  var attributesWithLowercaseType_value = attributes.value;
  var attributesWithLowercaseType_name = attributes.name;
  var attributesWithLowercaseType_title = attributes.title;
  var attributesWithLowercaseType_placeholder = attributes.placeholder;
  var attributesWithLowercaseType_selected = attributes.selected;
  var attributesWithLowercaseType_contenteditable = attributes.contenteditable;
  if (tagName !== "input") {
    return ;
  }
  var match = attributesWithLowercaseType_type_;
  if (match === "file") {
    return Caml_option.some(typecaseFromElement(element));
  }
  
}

exports.ofElement = ofElement;
/* No side effect */
